import { createAsyncThunk } from "@reduxjs/toolkit";
import type { ChatMessage } from "../chatMessage/chatMessage.entity";
import {
  updateChatMessageList,
  upsertChatMessageList,
} from "../chatMessage/chatMessageSlice";
import { getMessagePrimaryKey } from "../chatMessage/getMessagePrimaryKey";
import { createThunkName } from "../redux/createThunkNamespace";
import type { ThunkBase } from "../redux/types";

type ActiveChannelNewMessageEventThunkPayload = {
  messages: Record<string, ChatMessage>;
};
export const activeChannelNewMessageEventThunk = createAsyncThunk<
  void,
  ActiveChannelNewMessageEventThunkPayload,
  ThunkBase
>(
  createThunkName("activeChannelNewMessageEventThunk"),
  async ({ messages }, { dispatch }) => {
    dispatch(upsertChatMessageList(messages));
  },
);

type ReadMessageEventThunkPayload = {
  chatMessages: ChatMessage[];
};

export const readMessageEventThunk = createAsyncThunk(
  createThunkName("readMessageEventThunk"),
  async ({ chatMessages }: ReadMessageEventThunkPayload, { dispatch }) => {
    dispatch(
      updateChatMessageList(
        chatMessages.map((message) => ({
          id: getMessagePrimaryKey({
            message: { id: message.id, channelId: message.channel_id },
          }),
          changes: {
            seen: message.seen,
          },
        })),
      ),
    );
  },
);
